<div data-qa-id="icon-dialog-button" class="icon-container"><mat-icon class="icon" (click)="openDialog()" inline="false">info </mat-icon></div>
